import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { tgReady } from "./auth";
import "./index.css";

tgReady();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
